import type {
  CellType,
  ElementType,
  ImageType,
  MultipleSelectionType as BaseMultipleSelectionType,
  OptionType,
  PresetType,
  SingleSelectionType,
  TextareaType,
  TypographyType,
} from "./CellComponent";

export type {
  CellType,
  ElementType,
  ImageType,
  OptionType,
  PresetType,
  SingleSelectionType,
  TextareaType,
  TypographyType,
};

export interface MultipleSelectionType extends BaseMultipleSelectionType {
  correctOptionIndices?: number[];
  incorrectMessage?: string;
}

export const TASK_EDITOR_AUTOMATIC_THOUGHT_MOCK = Object.freeze({
  situationLabel: "상황",
  situation: "발표 시작 5분 전 나를 호명함",
  thoughtLabel: "자동적 사고",
  thought: "나는 발표를 망치게 될거야",
  emotionLabel: "감정",
  emotion: "불안, 두려움",
  physicalResponseLabel: "신체 반응",
  physicalResponse: "심장이 두근거림",
  behaviorLabel: "행동",
  behavior: "도망가고 싶음",
});

export interface AutomaticThoughtMockText {
  situationLabel?: string;
  situation?: string;
  thoughtLabel?: string;
  thought?: string;
  emotionLabel?: string;
  emotion?: string;
  physicalResponseLabel?: string;
  physicalResponse?: string;
  behaviorLabel?: string;
  behavior?: string;
}

export function Typography(
  translationKey: string,
  arg?: TypographyType
): { type: "typography"; content: TypographyType } {
  return {
    type: "typography",
    content: {
      translationKey,
      ...(arg && arg),
    },
  };
}

export function Textarea(arg?: TextareaType): {
  type: "textarea";
  content: TextareaType;
} {
  return {
    type: "textarea",
    content: { ...(arg && arg) },
  };
}

export function ButtonGroup(
  options: OptionType[],
  arg?: SingleSelectionType
): { type: "buttongroup"; content: SingleSelectionType } {
  return {
    type: "buttongroup",
    content: {
      options,
      ...(arg && arg),
    },
  };
}

export function ButtonGroupMultipleChoice(
  options: OptionType[],
  arg?: MultipleSelectionType
): { type: "buttongroup_multipleChoice"; content: MultipleSelectionType } {
  return {
    type: "buttongroup_multipleChoice",
    content: {
      options,
      ...(arg && arg),
    },
  };
}

export function Preset(arg?: PresetType): { type: "preset"; content: PresetType } {
  return {
    type: "preset",
    content: {
      coach: true,
      ...(arg && arg),
    },
  };
}

export function Image(url: string): { type: "image"; content: ImageType } {
  return {
    type: "image",
    content: {
      imageUrl: url,
    },
  };
}

export function DividerLine(
  arg?: TypographyType
): { type: "divider"; content: ElementType }[] {
  return [
    {
      type: "divider",
      content: { ...(arg && arg) },
    },
  ];
}

export function TypographyLine(
  text: string,
  arg?: TypographyType
): { type: "typography"; content: TypographyType }[] {
  return [Typography(text, arg)];
}

export function AutomaticThoughtMockLines(
  arg?: AutomaticThoughtMockText
): CellType[][] {
  const mockText = {
    ...TASK_EDITOR_AUTOMATIC_THOUGHT_MOCK,
    ...(arg ?? {}),
  };

  return [
    TypographyLine(mockText.situationLabel, { isLabel: true }),
    TypographyLine(mockText.situation),
    TypographyLine(mockText.thoughtLabel, { isLabel: true }),
    TypographyLine(mockText.thought),
    TypographyLine(mockText.emotionLabel, { isLabel: true }),
    TypographyLine(mockText.emotion),
    TypographyLine(mockText.physicalResponseLabel, { isLabel: true }),
    TypographyLine(mockText.physicalResponse),
    TypographyLine(mockText.behaviorLabel, { isLabel: true }),
    TypographyLine(mockText.behavior),
  ];
}
